import * as api from '../../Services/NetteApiClient';
import TestForm from './TestForm';
import { useState } from 'react';
import Text from '../Base/Text/Text';

export default function TestFormContainer(props) {
	const [result, setResult] = useState(null);

	const onSubmit = async function (values) {
		const tempResult = await api.post(props.onSubmitLink, values);

		setResult(JSON.stringify(tempResult.data?.result));
	};

	return (
		<div>
			<TestForm onSubmit={onSubmit} />

			<Text tx='result' />
			<Text tx={result} />
		</div>
	);
}
